import Api from '../api';

interface CreateColumnPayload {
  name: string;
  color: string;
  after_column_id?: number;
}

export const createColumn = (payload: CreateColumnPayload) =>
  Api.post('/gestao_ia/colunas', payload);

export const renameColumn = (id: number, name: string) =>
  Api.patch(`/gestao_ia/colunas/${id}`, { name });

export const recolorColumn = (id: number, color: string) =>
  Api.patch(`/gestao_ia/colunas/${id}`, { color });

interface DeleteColumnOptions {
  targetColumnId?: number;
}

export const deleteColumn = (id: number, options: DeleteColumnOptions = {}) =>
  Api.delete(`/gestao_ia/colunas/${id}`, {
    params: options.targetColumnId ? { target_column_id: options.targetColumnId } : undefined,
  });

export const reorderColumn = (id: number, afterColumnId: number) =>
  Api.patch(`/gestao_ia/colunas/${id}/reordenar`, { after_column_id: afterColumnId });
